/* eslint-disable no-unused-vars */
import { createContext } from 'react';
var ModalContext = /*#__PURE__*/createContext({
  windows: {},
  addWindows: function addWindows() {},
  removeWindow: function removeWindow() {},
  updateWindow: function updateWindow() {},
  setActiveWindow: function setActiveWindow() {},
  activeWindow: ''
});
export default ModalContext;